import React from 'react'
import initApollo from './InitApollo'
import Head from 'next/head'
import { getDataFromTree } from '@apollo/client/react/ssr'

const WithApolloClient = (App) => {
  return class Apollo extends React.Component {
    static displayName = 'withApollo(App)'
    static async getInitialProps(ctx) {
      const {
        ctx: { req, AppTree },
      } = ctx
      let appProps = {}
      if (App.getInitialProps) {
        appProps = await App.getInitialProps(ctx)
      }

      // Run all GraphQL queries in the component tree
      // and extract the resulting data
      var { pageProps } = appProps
      const cookies = req?.headers?.cookie
      const apolloClient = initApollo(
        null,
        pageProps.environment,
        pageProps.domain,
        pageProps.host,
        cookies,
        pageProps.cloudflareForwardedIp
      )
      const shouldBuildCache = !pageProps.isServerSideRedirect && !process.browser
      if (shouldBuildCache) {
        try {
          // Run all GraphQL queries
          await getDataFromTree(<AppTree {...appProps} apolloClient={apolloClient} />)
        } catch (error) {
          // Prevent Apollo Client GraphQL errors from crashing SSR.
          // Handle them in components via the data.error prop:
          // https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-query-data-error
          console.error('Error while running `getDataFromTree`', error)
        }

        // getDataFromTree does not call componentWillUnmount
        // head side effect therefore need to be cleared manually
        Head.rewind()
      }

      // Extract query data from the Apollo store
      const apolloState = apolloClient.cache.extract()
      return {
        ...appProps,
        apolloState,
      }
    }

    constructor(props) {
      super(props)
      const { pageProps, apolloClient } = props
      if (apolloClient) {
        this.apolloClient = apolloClient
      } else {
        this.apolloClient = initApollo(
          props.apolloState,
          pageProps.environment,
          pageProps.domain,
          pageProps.host,
          null,
          pageProps.cloudflareForwardedIp
        )
      }
    }

    render() {
      return <App {...this.props} apolloClient={this.apolloClient} />
    }
  }
}

export default WithApolloClient
